import React from 'react';
import { Button } from '@components/atoms/Button';
import { cn } from '@utils/cn';
import { useViewportHeight } from '@hooks/useViewportHeight';
import { useTranslation } from '@hooks/useTranslation';

interface EmptyDataProps {
  textButton?: string;
  description?: string;
  onClickButton?: () => void;
  iconButton?: React.ReactNode;
  fullHeight?: boolean;
  className?: string;
  disabled?: boolean;
}

export const EmptyData: React.FC<EmptyDataProps> = ({
  textButton,
  description,
  onClickButton,
  iconButton,
  fullHeight = false,
  className,
  disabled = false,
}) => {
  const { availableHeight } = useViewportHeight();
  // Sprint 28, story-142. Decision 2 (docs/architecture.md "## Sprint 28") — own default,
  // context-independent copy via `common.*`; a feature screen with entity-specific empty copy
  // still passes `description` as a prop override.
  const tCommon = useTranslation('common');

  // Calculate dynamic height with padding bottom (4 units = 16px)
  const dynamicHeight = fullHeight ? Math.max(availableHeight - 16, 400) : undefined;

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-md w-full border-2 border-gray-300 dark:border-gray-600 gap-4 p-8',
        !fullHeight && 'h-full min-h-48',
        className,
      )}
      style={fullHeight ? { height: `${dynamicHeight}px` } : undefined}>
      <div className="text-gray-500 dark:text-gray-400 text-base font-medium">
        {description || tCommon.noResults}
      </div>
      {textButton && (
        <Button onClick={onClickButton} leftIcon={iconButton} disabled={disabled}>
          {textButton}
        </Button>
      )}
    </div>
  );
};
